import { GiTrophyCup } from "react-icons/gi";
import useUserInfo from "../../hooks/useUserInfo";

export default function OwnTable({ leaderboard }) {
    const user = useUserInfo();
    const { serial, student_name, totalQuizMark, totalAssignmentMark, totalMark } = leaderboard.find(item => item.student_id === user.id) || {}

    return (
        <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
            <thead>
                <tr>
                    <th className="table-th !text-center">Rank</th>
                    <th className="table-th !text-center">Name</th>
                    <th className="table-th !text-center">Quiz Mark</th>
                    <th className="table-th !text-center">Assignment Mark</th>
                    <th className="table-th !text-center">Total</th>
                </tr>
            </thead>

            <tbody>
                 
                <tr className="border-2 border-cyan">
                    <td className="table-td text-center font-bold flex justify-center items-center">{serial === 1 ? <GiTrophyCup className="text-[#ffd700]" /> : serial}</td>
                    <td className="table-td text-center font-bold">{student_name}</td>
                    <td className="table-td text-center font-bold">{totalQuizMark ? totalQuizMark : 0}</td>
                    <td className="table-td text-center font-bold">{totalAssignmentMark ? totalAssignmentMark : 0}</td>
                    <td className="table-td text-center font-bold">{totalMark ? totalMark : 0}</td>
                </tr>
            </tbody>
        </table>
    )
};